export default "__VITE_ASSET__DM9NK10H__"